export default __webpack_public_path__ + "static/media/042-first-aid-kit.c9bf3f34.png";